module.exports = __webpack_public_path__ + "img/icon-advert2.f071aa96.png";